import { Injectable } from "@nestjs/common";
import { InjectDataSource } from "@nestjs/typeorm";
import { CommonResponseModel, GantColorColumn, TommyNaColorColumn } from "@project-management-system/shared-models";
import { DataSource } from "typeorm";
import { GenericTransactionManager } from "../../../typeorm-transactions";
import { ColorEntity } from "./color-entity";
import { ColorRepository } from "./color-repo";

@Injectable()
export class ColorService {
    constructor(
        @InjectDataSource()
        private dataSource: DataSource,
        private repo: ColorRepository
    ) { }

    async saveColorInfo(formData: any): Promise<CommonResponseModel> {
        const transactionManager = new GenericTransactionManager(this.dataSource);
        try {
            await transactionManager.startTransaction();
            const columnArray = [];
            const updatedArray = formData.map((obj) => {
                const sanitizedObj = {};
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
                    if (newKey) {
                        columnArray.push(newKey);
                        sanitizedObj[newKey] = obj[key];
                    }
                }
                return sanitizedObj;
            });

            const invalidColumns = columnArray.filter((col) => !GantColorColumn.includes(col));
            if (invalidColumns.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponseModel(false, 1110, "Excel columns don't match. Please attach the correct file.");
            }
            const filteredArray = updatedArray.filter((obj) => {
                return Object.values(obj).every((value) => value !== null && value !== '' && value !== '-' && value !== ' ');
            });
            const convertedData = filteredArray.map((obj) => {
                const result = {};
                for (const key in obj) {
                    result[key] = obj[key] === "" ? null : obj[key];
                }
                return result;
            });
            const repository = transactionManager.getRepository(ColorEntity);
            for (const data of convertedData) {
                if (!data) continue;
                const existingRecord = await repository.findOne({
                    where: {
                        item: data.Item,
                        style: data.Style,
                        colorCode: data.ColorCode,
                        movexColorName: data.MovexColorName.toUpperCase(),
                    },
                });
                if (existingRecord) {
                    continue;
                }
                const newRecord = {
                    item: data.Item,
                    style: data.Style,
                    colorCode: data.ColorCode,
                    movexColorName: data.MovexColorName.toUpperCase(),
                };
                const savedRecord = await repository.save(newRecord);
                if (!savedRecord) {
                    console.error("Failed to save record:", data);
                    await transactionManager.releaseTransaction();
                    return new CommonResponseModel(false, 0, "Failed to save some records");
                }
            }
            await transactionManager.completeTransaction();
            return new CommonResponseModel(true, 1, "Data saved successfully");
        } catch (err) {
            console.error(err, "Error saving color info");
            await transactionManager.releaseTransaction();
            return new CommonResponseModel(false, 0, "An error occurred while processing the data");
        }
    }

    async getColorInfo(): Promise<CommonResponseModel> {
        try {
            const info = await this.repo.find()
            if (info) {
                return new CommonResponseModel(true, 1, 'Data retrieved', info)
            } else {
                return new CommonResponseModel(false, 0, 'No data found')
            }
        } catch (err) {
            return new CommonResponseModel(false, 0, 'Something went wrong', err)
        }
    }




}